export function AnchorScrollTo(offset = 0) {

    document.addEventListener('click', function(e) {

        if (e.target.tagName === 'A') {
            const href = e.target.getAttribute('href')
            if (href.indexOf('#') === 0 && href.length > 1) {
                
                const scrollTarget = document.querySelector(href);

                if (scrollTarget) {
                    e.preventDefault();
                } else {
                    return;
                }
                const yVal = window.pageYOffset + scrollTarget.getBoundingClientRect().top - offset

                setTimeout( () => {
                    window.scrollTo({
                        top: yVal,
                        left: 0,
                        behavior: 'smooth'
                    });
                },1)
            }

        }
    })

}